import { useEffect, useState } from 'react';

import Spin from './Spin';

const TIME_BEFORE_VISIBLE = 5000;
const TIME_STEP = 1000;
const DEFAULT_TIME = 1;

const CancelButton = ({ spinning, onCancel }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (spinning) {
            const timeoutId = setTimeout(() => setVisible(true), TIME_BEFORE_VISIBLE);
            return () => {
                setVisible(false);
                clearTimeout(timeoutId);
            };
        }
    }, [spinning]);

    if (visible)
        return (
            <button
                className="cursor-pointer rounded px-4 py-1 text-xs font-semibold text-slate-900 hover:bg-blue-500 dark:text-font-primary dark:hover:bg-blue-700/60"
                onClick={onCancel}
            >
                Отменить
            </button>
        );
    return null;
};

const RestartIcon = props => (
    <svg width={25} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.806 7.567a1 1 0 0 1-.609.467l-3.07.815a1 1 0 1 1-.514-1.932l2.1-.558-.567-2.098a1 1 0 1 1 1.93-.522l.83 3.067a1 1 0 0 1-.1.761Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.098 5.817a6.108 6.108 0 1 0 5.51 6.078 1 1 0 1 1 2 0 8.108 8.108 0 1 1-2.375-5.733 1 1 0 0 1-1.414 1.414c-1-.999-2.314-1.62-3.72-1.76Z"
        />
    </svg>
);

const RestartButton = ({ onRestart }) => {
    return (
        <>
            <RestartIcon className="fill-blue-700" />
            <button
                className="cursor-pointer rounded px-4 py-1 text-xs font-semibold text-slate-900 hover:bg-blue-500 dark:text-font-primary dark:hover:bg-blue-700/60"
                onClick={onRestart}
            >
                Обновить
            </button>
        </>
    );
};

const SpinWithTime = ({ spinning }) => {
    const [time, setTime] = useState(DEFAULT_TIME);

    useEffect(() => {
        if (spinning) {
            const intervalId = setInterval(() => setTime(t => t + 1), TIME_STEP);
            return () => {
                clearInterval(intervalId);
                setTime(DEFAULT_TIME);
            };
        }
    }, [spinning]);

    return (
        <div className="relative flex justify-center ">
            <span
                className="text-xs text-slate-900 dark:text-font-quarternary"
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                }}
            >
                {time}
            </span>
            <Spin spinning={spinning} size="large" tip="" />
        </div>
    );
};

const SpinWithCancel = ({ spinning, size, tip, onCancel }) => {
    const isLarge = size === 'large';

    return (
        <>
            {isLarge ? <SpinWithTime spinning={spinning} /> : <Spin spinning={spinning} size={size} tip="" />}
            {tip ? <span className="text-xs text-blue-700">{tip}</span> : null}
            <CancelButton spinning={spinning} onCancel={onCancel} />
        </>
    );
};

export const SpinWithControll = ({
    className = '',
    overlayClassName = '',
    spinning = true,
    canceled = false,
    size = 'default',
    children = null,
    tip = null,
    onCancel,
    onRestart,
}) => {
    const display = spinning || canceled ? 'flex' : 'hidden';
    const overlayBg = children ? 'bg-white/70 dark:bg-block-tertiary/60' : '';
    const spinBg = children ? 'bg-white dark:bg-block-secondary' : '';

    return (
        <div className={`spin-with-controll relative h-full w-full ${className}`}>
            <div
                className={`absolute inset-0 ${display} z-10 items-center justify-center ${overlayBg} ${overlayClassName}`}
            >
                <div className={`flex flex-col items-center justify-center gap-y-4 rounded px-2 py-2 ${spinBg}`}>
                    {canceled ? (
                        <RestartButton onRestart={onRestart} />
                    ) : (
                        <SpinWithCancel spinning={spinning} size={size} tip={tip} onCancel={onCancel} />
                    )}
                </div>
            </div>
            {children}
        </div>
    );
};
